import { Container } from './styled';
import { StatusMessage } from '../../components';

export function Footer(props) {

  const { message } = props;
  
  const isUserSystem = message?.user_system;

  function getTimeFromMessage(message) {
    const timeString = message?.date?.split(" ")[1];
    if (!timeString) return null;
    const [hh, mm] = timeString.split(":");
    const time = `${hh}:${mm}`;

    return time;
  }

  return (
    <Container isUserSystem={isUserSystem}>
      {isUserSystem
        ?
        <>
          <span className='msg--nameAuthor'>
            {"Enviado por " + message.author}
          </span>
          <span className='msg--status'>
            {getTimeFromMessage(message)}
            <StatusMessage message={message} />
          </span>
        </>
        : <>
          {getTimeFromMessage(message)}
        </>
      }
    </Container>
  );
}